module.exports = __webpack_public_path__ + "static/media/alert.fa8d5c52.svg";